import * as React from "react";

import { Button, type ButtonProps } from "./Button";
import { Tooltip } from "./Tooltip";

export interface IconButtonProps
  extends Omit<ButtonProps, "leftIcon" | "rightIcon" | "children" | "size"> {
  /** Accessible name, also shown as a tooltip unless `hideTooltip` is set. */
  label: string;
  icon: React.ReactNode;
  size?: "sm" | "md";
  hideTooltip?: boolean;
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ label, icon, size = "md", variant = "ghost", hideTooltip = false, ...props }, ref) => {
    const button = (
      <Button
        ref={ref}
        aria-label={label}
        variant={variant}
        size={size === "sm" ? "icon-sm" : "icon"}
        {...props}
      >
        {icon}
      </Button>
    );
    return hideTooltip ? button : <Tooltip content={label}>{button}</Tooltip>;
  }
);
IconButton.displayName = "IconButton";
